import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ThemeLookupsOverview from '../components/ThemeLookupsOverview';

const ThemeLookupsScene = () => (
  <Routes>
    <Route
      path=":action?/:id?"
      element={<ThemeLookupsOverview menuName="themeLookups_plural" />}
    />
  </Routes>
);

export default ThemeLookupsScene;
